<template>
  <div class="content" style="background-size: cover;" v-if="!notFound">
    <Header></Header>
    <div class="nav">
      <span class="">{{$t('game_list')}}</span>
    </div>
    <div class="game-list" style="text-align: center;margin-top:30px;padding-bottom: 50px;">

      <div  v-for="(item,index) in product">
        <div class="por" @click="goGame(item.web_path)" style="margin: 50px 0;">
          <img :src="item.image" loading="lazy">
          <div class="game1-btn">
            <span>{{item.title_tip}}</span>
            <button class="btn-yl fw7">{{$t('Play')}} ></button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import Header from '../components/header'
export default {
  components:{
    Header
  },
  data() {

    return {
      notFound: false,
      isEN:'bur',
      product:{},

    }
  },
  watch: {},
  computed: {},
  mounted() {
  },
  created() {
    this.getProduct()
  },
  beforeDestroy(){
    console.log('beforeDestroy')
  },
  destroyed() {
    console.log('页面已销毁');
  },
  methods: {
    back() {
      this.$router.push({path: '/'})
    },
    goGame(type) {
      this.isEN = localStorage.getItem('lang')?localStorage.getItem('lang'):"bur"
      if (type =="gameCar"){
        this.$parent.loadModal(true);
        let url = 'https://dialog-game.gbgts.com/pages/game/car/index?user_id=' + this.$route.query.user_id + '&lang=' + this.isEN + '&t=' + Date.now();
        // let url = 'http://localhost:8081/pages/game/car/index?user_id=' + this.$route.query.user_id + '&lang=' + this.isEN + '&t=' + Date.now();
        setTimeout(() => {
          this.$parent.loadModal(false);
          window.location.href = url;
        }, 100);
      }else {
        this.$router.push({path: '/'+type,query:{user_id: this.$route.query.user_id}});
      }
    },
    getProduct(){
      let that =this;
      that.$parent.loadModal(true);
      that.$api.get('/api/game/list',null,r =>{
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          that.product=r.data
        });
      })
    },

  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/gameList.vue